import {translations} from "../../constants/translations";

class PaginationModel {

    /**
     * @description
     * Constructor method
     *
     * @param {object} Options hash used to set page_size and max_size
     */
    constructor(options) {
        this.current_page = 1;
        this.page_size = options.page_size || 10;
        this.request_page_size = options.request_page_size || this.page_size;
        this.max_size = options.max_size || 5;
        this.num_pages = null;
        this.num_items = null;
        this.items = [];
    }


    /**
     * @description
     * Initiailises the pagination instance when first page has been retrieved
     *
     * @param {array} The first page of items returned by the API
     * @param {integer} The total number of items
     */
    initialise(items, total_items) {
        this.current_page = 1;
        this.items = items || [];
        this.num_items = total_items || 0;
        return this.update();
    }


    /**
     * @description
     * Updates the pagination summary when the page changes
     *
     * @returns {boolean} Flag to indicate if items in current page are present
     * @returns {integer} The page to load based on
     */
    update() {
        const start = ((this.current_page - 1) * this.page_size) + 1;
        let end = this.current_page * this.page_size;
        end = this.num_items < end ? this.num_items : end;
        const total = end >= 100 ? '100+' : end;
        //this.summary = $translate.instant('CORE.PAGINATION.SUMMARY', {start, end, total}); TODO !!!
        this.summary = translations.MODEL.PAGINATION.SUMMARY;

        const page_to_load = Math.ceil((this.current_page * this.page_size) / this.request_page_size);

        return [(this.items[start - 1] != null), page_to_load];
    }


    /**
     * @description
     * Appends additional items (from subsequent data requests) to items array
     *
     * @param {integer} The page number of the data request
     * @param {array} The new items
     *
     */
    add(request_page, new_items) {
        const start = (request_page - 1) * this.request_page_size;
        return Array.from(new_items).map((item, index) =>
            this.items[start + index] = item);
    }
}

export {
    PaginationModel
}